import {sizeOfArray} from "@acng/frontend-bounty";
import {RESOURCE_CONFIG} from "../../model/resource.js";

/**
 * @typedef {import("../../model/resource").ResourceElement} ResourceElement
 * @typedef {import("../../model/resource").ConfigCallback} ConfigCallback
 */

/**
 * @param {ResourceElement} resource
 * @param {Array<ConfigCallback>} configCallbacks
 */
export const setConfig = (resource, configCallbacks) => {
  if (!sizeOfArray(configCallbacks)) {
    delete resource[RESOURCE_CONFIG];
  } else {
    resource[RESOURCE_CONFIG] = configCallbacks;
  }
};
